import { render, staticRenderFns } from "./ThirdPartyDelivery.vue?vue&type=template&id=c7527762&scoped=true"
import script from "./ThirdPartyDelivery.vue?vue&type=script&lang=js"
export * from "./ThirdPartyDelivery.vue?vue&type=script&lang=js"
import style0 from "./ThirdPartyDelivery.vue?vue&type=style&index=0&id=c7527762&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7527762",
  null
  
)

export default component.exports